import React from 'react';

const Assessment = ({ serviceData }) => {
    return (
        <span>
            {
            serviceData.is_offline == 0 ? 
                "آنلاین":
            serviceData.is_offline == 1 &&
                "آفلاین"
            }
        </span>
    );
}

export default Assessment;
